import * as Types from './types';

export const isSwipeDenied = ({
    loop, isMirrorMode, swipeDeltaX, activeSlide, slidesCount, itemsPerView
}: Types.IIsSwipeDenied): boolean => {
    if (loop) {
        return false;
    }

    return (isMirrorMode ? swipeDeltaX < 0 : swipeDeltaX > 0) && activeSlide >= slidesCount - itemsPerView
        || (isMirrorMode ? swipeDeltaX > 0 : swipeDeltaX < 0) && activeSlide === 0;
};
